module.exports = __webpack_public_path__ + "img/login-img.09da62c0.png";